











import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    pageDataType
} from "../types";
import BannerTextBlock from "../components/BannerTextBlock.vue";
import ImgTitleCard from "../components/ImgTitleCard.vue";
import Missionslider from "../components/Missionslider.vue";
import AbValuecard from "../components/AbValuecard.vue";
import SingleTitle from "../components/SingleTitle.vue";
import TlTwoCards from "../components/TlTwoCards.vue";
import SmBanner from "../components/SmBanner.vue";
import FranchiseeCard from "../components/FranchiseeCard.vue";
import RichtextBlock from "../components/RichtextBlock.vue";
import Dform from "../components/Dform.vue";
import TitleText from "../components/TitleText.vue";
import BrandItem from "../components/BrandItem.vue";
import Ecommercard from "../components/Ecommercard.vue";
import LocalTeamBlock from "../components/LocalTeamBlock.vue";
import LeftTitileText from "../components/LeftTitileText.vue";
import ProfileBlock from "../components/ProfileBlock.vue";
import GlobalLocalCard from "../components/GlobalLocalCard.vue";
import ProfileText from "../components/ProfileText.vue";
import Responsibilitycard from "../components/Responsibilitycard.vue";
import CountryList from "../components/CountryList.vue";
import CardList from "../components/CardList.vue";
import LogoCardList from "../components/LogoCardList.vue";
import LogoImgCardList from "../components/LogoImgCardList.vue";
import Securitylogo from "../components/Securitylogo.vue";
import TitleimgCard from "../components/TitleimgCard.vue";
import SingleText from "../components/SingleText.vue";
import CsrCard from "../components/CsrCard.vue";
import FullRichText from "../components/FullRichText.vue";
import SeejobLink from "../components/SeejobLink.vue";
import BenefitsList from "../components/BenefitsList.vue";
import Videoblock from "../components/Videoblock.vue";
import VideoBanner from "../components/VideoBanner.vue";
import StoryTextBlock from "../components/StoryTextBlock.vue";
import GpSlider from "../components/GpSlider.vue";
import TitleRichText from "../components/TitleRichText.vue";
import GlobalProductCard from "../components/GlobalProductCard.vue";
import ProductHighlights from "../components/ProductHighlights.vue";
import ManagementTeam from "../components/ManagementTeam.vue";
import Credentiacard from '../components/Credentiacard.vue';
import VrSupplyChain from "../components/VrSupplyChain.vue";
import RichTextChooser from "../components/RichTextChooser.vue";
import HowWework from "../components/HowWework.vue";
import GlobalMap from '../components/GlobalMap.vue';
import StoreLocatorMap from "../components/StoreLocatorMap.vue";
import JobCompleteCard from "../components/JobCompleteCard.vue";
import Smfullimgblock from '../components/Smfullimgblock.vue';
import GlobalFootWearIndystry from '../components/GlobalFootWearIndystry.vue';
import ChartDataTable from '../components/ChartDataTable.vue';
import SingleChartBlock from '../components/SingleChartBlock.vue';
import MaterialChartBlock from '../components/MaterialChartBlock.vue';
import GrowthChartBlock from '../components/GrowthChartBlock.vue';
import IndustryRichText from '../components/IndustryRichText.vue';
import ProductView from '../components/ProductView.vue';
import AOS from "aos";

import {
    HOST
} from "../global";
import {
    TimelineMax,
    TimelineLite,
    Expo,
    Power2
} from "gsap";

@Component({
    name: "ApexBasicPage",

    components: {
        banner: BannerTextBlock,
        double_title_image: ImgTitleCard,
        title_image_slider: Missionslider,
        value_block: AbValuecard,
        single_title: SingleTitle,
        history: TlTwoCards,
        rich_text_with_chooser: RichTextChooser,
        subtitle_image: SmBanner,
        title_text_image_with_alignment: FranchiseeCard,
        title_text_cta: RichtextBlock,
        dealer_form: Dform,
        title_text: TitleText,
        brand_logos: BrandItem,
        image_text_cta: Ecommercard,
        team_block: LocalTeamBlock,
        title_text_with_alignment: LeftTitileText,
        leadership_block: ProfileBlock,
        management_cta_block: GlobalLocalCard,
        title_subtitle_text_image: ProfileText,
        country_block: CountryList,
        responsibility_type: Responsibilitycard,
        text_blur_image_card: CardList,
        title_text_image_card: LogoCardList,
        responsibility_image_logo: LogoImgCardList,
        single_image_list: Securitylogo,
        title_image_card: TitleimgCard,
        single_text: SingleText,
        title_image_box_cta: CsrCard,
        rich_text: FullRichText,
        title_plain_text_cta: SeejobLink,
        title_richtext_list: BenefitsList,
        youtube_video: Videoblock,
        video_banner: VideoBanner,
        our_story_block: StoryTextBlock,
        title_text_image_slider: GpSlider,
        title_rich_text: TitleRichText,
        title_richtext_image_with_alignment: GlobalProductCard,
        product_highlight_block: ProductHighlights,
        management_block: ManagementTeam,
        global_award_block: Credentiacard,
        global_presence_common_block: VrSupplyChain,
        store_locator_block: StoreLocatorMap,
        how_we_work_block: HowWework,
        world_map: GlobalMap,
        title_image_richtext_list: JobCompleteCard,
        single_image: Smfullimgblock,
        result_summary_block: GlobalFootWearIndystry,
        heat_map_visual_block: ChartDataTable,
        piechart_block: SingleChartBlock,
        growth_chart_block: GrowthChartBlock,
        industry_rich_text: IndustryRichText,
        material_chart_block: MaterialChartBlock,
        three60_degree_images: ProductView

    }
})
export default class ApexBasicPage extends Vue {
    @Prop() pageData!: pageDataType | null;
    public HOST: string = HOST;
    public created() {
        AOS.init();
    }
    
}
